export * from './future-date.directive';



// WEBPACK FOOTER //
// ./src/app/directives/index.ts